import {
  HEADER_EVENTS,
  HEADER_FLOW,
  HEADER_INFO,
  HEADER_MAP,
  HEADER_MEDIA,
  HEADER_PERF,
  HEADER_SHOPPERS,
} from './headerPaths';

export const MALL_BASE = '/mall';

export const MALL_MAP = MALL_BASE + HEADER_MAP;
export const MALL_PERF = MALL_BASE + HEADER_PERF;
export const MALL_FLOW = MALL_BASE + HEADER_FLOW;
export const MALL_INFO = MALL_BASE + HEADER_INFO;
export const MALL_SHOPPERS = MALL_BASE + HEADER_SHOPPERS;
export const MALL_MEDIA = MALL_BASE + HEADER_MEDIA;
export const MALL_EVENTS = MALL_BASE + HEADER_EVENTS;

export const MALL_MEDIA_LAYOUT = `${MALL_MEDIA}/layout`;
export const MALL_MEDIA_PICTURE = `${MALL_MEDIA}/picture`;
export const MALL_MEDIA_BROCHURE = `${MALL_MEDIA}/brochure`;
export const MALL_MEDIA_VIDEO = `${MALL_MEDIA}/video`;
export const MALL_MEDIA_VISIT = `${MALL_MEDIA}/visit`;
